import { CheckIcon } from "lucide-react";

import {
  ContextMenuItem,
  ContextMenuSub,
  ContextMenuSubContent,
  ContextMenuSubTrigger
} from "@/components/ui/context-menu";

const TableToolbar: React.FC<
  React.ComponentProps<"div"> & {
    rightClickedElement: HTMLElement;
  }
> = ({ rightClickedElement }) => {
  if (!rightClickedElement?.id) return <></>;

  const container = rightClickedElement.parentElement as HTMLDivElement;
  const searchWrapper = container.querySelector(
    "#table-search-wrapper"
  ) as HTMLDivElement | null;
  const tableActionsWrapper = container.querySelector(
    "#table-actions-wrapper"
  ) as HTMLDivElement | null;
  const advancedSearchWrapper = container.querySelector(
    "#table-advanced-search-button"
  ) as HTMLDivElement | null;
  const exportButton = container.querySelector(
    "#table-export-button"
  ) as HTMLButtonElement | null;
  const shareButton = container.querySelector(
    "#table-share-button"
  ) as HTMLButtonElement | null;
  const sortWrapper = container.querySelector(
    "#table-sort-wrapper"
  ) as HTMLDivElement | null;
  const paginationWrapper = container.querySelector(
    "#table-pagination-wrapper"
  ) as HTMLDivElement | null;
  const repeaterWrapper = container.querySelector(
    "#table-repeater-wrapper"
  ) as HTMLDivElement | null;

  const hasSearch = searchWrapper
    ? searchWrapper.style.display !== "none"
    : false;
  const hasAdvancedSearch = advancedSearchWrapper
    ? advancedSearchWrapper.style.display !== "none"
    : false;
  const hasExport = exportButton
    ? exportButton.style.display !== "none"
    : false;
  const hasShare = shareButton ? shareButton.style.display !== "none" : false;
  const hasSort = sortWrapper ? sortWrapper.style.display !== "none" : false;
  const hasPagination = paginationWrapper
    ? paginationWrapper.style.display !== "none"
    : false;
  const hasRepeater = repeaterWrapper
    ? repeaterWrapper.style.display !== "none"
    : false;

  return (
    <ContextMenuSub>
      <ContextMenuSubTrigger>ابزار</ContextMenuSubTrigger>
      <ContextMenuSubContent>
        <ContextMenuItem
          className="flex items-center justify-between"
          onClick={() => {
            if (!advancedSearchWrapper) return;

            advancedSearchWrapper.style.display = hasAdvancedSearch
              ? "none"
              : "flex";
          }}
        >
          سرچ پیشرفته
          {hasAdvancedSearch && (
            <CheckIcon size={16} className="text-primary" />
          )}
        </ContextMenuItem>
        <ContextMenuItem
          className="flex items-center justify-between"
          onClick={() => {
            if (!exportButton) return;

            exportButton.style.display = hasExport ? "none" : "flex";

            if (tableActionsWrapper) {
              const hasVisibleActions =
                exportButton.style.display !== "none" ||
                shareButton?.style.display !== "none" ||
                sortWrapper?.style.display !== "none";
              tableActionsWrapper.style.display = hasVisibleActions
                ? "flex"
                : "none";
            }
          }}
        >
          خروجی
          {hasExport && <CheckIcon size={16} className="text-primary" />}
        </ContextMenuItem>
        <ContextMenuItem
          className="flex items-center justify-between"
          onClick={() => {
            if (!shareButton) return;

            shareButton.style.display = hasShare ? "none" : "flex";

            if (tableActionsWrapper) {
              const hasVisibleActions =
                exportButton?.style.display !== "none" ||
                shareButton.style.display !== "none" ||
                sortWrapper?.style.display !== "none";
              tableActionsWrapper.style.display = hasVisibleActions
                ? "flex"
                : "none";
            }
          }}
        >
          اشتراک گذاری
          {hasShare && <CheckIcon size={16} className="text-primary" />}
        </ContextMenuItem>
        <ContextMenuItem
          className="flex items-center justify-between"
          onClick={() => {
            if (!sortWrapper) return;

            sortWrapper.style.display = hasSort ? "none" : "flex";

            if (tableActionsWrapper) {
              const hasVisibleActions =
                exportButton?.style.display !== "none" ||
                shareButton?.style.display !== "none" ||
                sortWrapper.style.display !== "none";
              tableActionsWrapper.style.display = hasVisibleActions
                ? "flex"
                : "none";
            }
          }}
        >
          مرتب سازی
          {hasSort && <CheckIcon size={16} className="text-primary" />}
        </ContextMenuItem>
        <ContextMenuItem
          className="flex items-center justify-between"
          onClick={() => {
            if (!searchWrapper) return;

            searchWrapper.style.display = hasSearch ? "none" : "flex";
          }}
        >
          سرچ
          {hasSearch && <CheckIcon size={16} className="text-primary" />}
        </ContextMenuItem>
        <ContextMenuItem
          className="flex items-center justify-between"
          onClick={() => {
            if (!paginationWrapper) return;

            paginationWrapper.style.display = hasPagination ? "none" : "flex";
          }}
        >
          صفحه بندی
          {hasPagination && <CheckIcon size={16} className="text-primary" />}
        </ContextMenuItem>
        <ContextMenuItem
          className="flex items-center justify-between"
          onClick={() => {
            if (!repeaterWrapper) return;

            repeaterWrapper.style.display = hasRepeater ? "none" : "flex";
          }}
        >
          تکرار شونده
          {hasRepeater && <CheckIcon size={16} className="text-primary" />}
        </ContextMenuItem>
      </ContextMenuSubContent>
    </ContextMenuSub>
  );
};

export default TableToolbar;
